import { render, staticRenderFns } from "./LinkMissingAccountInfoPage.vue?vue&type=template&id=45160280&scoped=true"
import script from "./LinkMissingAccountInfoPage.vue?vue&type=script&lang=js"
export * from "./LinkMissingAccountInfoPage.vue?vue&type=script&lang=js"
import style0 from "./LinkMissingAccountInfoPage.vue?vue&type=style&index=0&id=45160280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45160280",
  null
  
)

export default component.exports